import { render, staticRenderFns } from "./ed-presentation-mode-header.component.vue?vue&type=template&id=d196e516&scoped=true&"
import script from "./ed-presentation-mode-header.component.ts?vue&type=script&lang=ts&"
export * from "./ed-presentation-mode-header.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-presentation-mode-header.component.scss?vue&type=style&index=0&id=d196e516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d196e516",
  null
  
)

export default component.exports